import _taggedTemplateLiteral from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _templateObject, _templateObject2;
import React, { useEffect, useState } from "react";
import { FieldArray } from "react-final-form-arrays";
import styled from "@emotion/styled";
import { AutoSizer, List, CellMeasurer, CellMeasurerCache } from "react-virtualized";
import { Flex, Box, Text } from "@rebass/emotion";
import { AddIcon, RemoveIcon, SearchIcon } from "@edenlabllc/ehealth-icons";
import Link from "../Link";
import FieldView from "./FieldView";
import Form from "../Form";
import Field from "./Field";
var ROW_HEIGHT = 69;
var ROW_COUNT = 7;
var MAX_CONTAINER_HEIGHT = ROW_HEIGHT * ROW_COUNT;
var Row = function Row(_ref) {
  var key = _ref.key,
    index = _ref.index,
    style = _ref.style,
    parent = _ref.parent,
    isScrolling = _ref.isScrolling,
    name = _ref.name,
    fields = _ref.fields,
    render = _ref.render,
    disableRemove = _ref.disableRemove,
    rowLoaderText = _ref.rowLoaderText,
    cache = _ref.cache;
  if (isScrolling) return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    key: key,
    style: style
  }, /*#__PURE__*/React.createElement(Box, null, rowLoaderText));
  return /*#__PURE__*/React.createElement(CellMeasurer, {
    cache: cache,
    columnIndex: 0,
    parent: parent,
    rowIndex: index
  }, function (_ref2) {
    var registerChild = _ref2.registerChild;
    return /*#__PURE__*/React.createElement("div", {
      key: name,
      style: style,
      ref: registerChild
    }, /*#__PURE__*/React.createElement(Item, null, render({
      name: name,
      index: index,
      fields: fields
    }), disableRemove || /*#__PURE__*/React.createElement(RemoveButtom, {
      icon: /*#__PURE__*/React.createElement(RemoveIcon, null),
      index: index,
      onClick: function onClick() {
        return fields.remove(index);
      }
    })));
  });
};
var VirtualizedList = function VirtualizedList(_ref3) {
  var name = _ref3.name,
    fields = _ref3.fields,
    searchTerm = _ref3.searchTerm,
    setSearchTerm = _ref3.setSearchTerm,
    row = _ref3.row,
    setRow = _ref3.setRow,
    disableRemove = _ref3.disableRemove,
    searchPlaceholderText = _ref3.searchPlaceholderText,
    foundLabel = _ref3.foundLabel,
    rowLoaderText = _ref3.rowLoaderText,
    selectFieldPlaceholderText = _ref3.selectFieldPlaceholderText,
    render = _ref3.render;
  var filteredList = fields && fields.value && fields.value.filter(function (item) {
    return (item || "").toLowerCase().includes((searchTerm || "").toLowerCase());
  });
  var isSearchVisible = fields.length > 10;
  var handleSearch = function handleSearch(e) {
    setSearchTerm(e.code);
  };
  var cache = new CellMeasurerCache({
    defaultHeight: ROW_HEIGHT,
    fixedWidth: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isSearchVisible && /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit() {
      return null;
    }
  }, /*#__PURE__*/React.createElement(Form.AutoSubmit, {
    onSubmit: handleSearch
  }), /*#__PURE__*/React.createElement(Flex, {
    mt: 3,
    mb: 3,
    justifyContent: "start"
  }, /*#__PURE__*/React.createElement(Box, {
    width: 1 / 3
  }, /*#__PURE__*/React.createElement(Field.Text, {
    name: "code",
    placeholder: searchPlaceholderText,
    postfix: /*#__PURE__*/React.createElement(SearchIcon, {
      color: "silverCity"
    })
  })), /*#__PURE__*/React.createElement(Box, {
    width: 1 / 3,
    ml: 3
  }, !!searchTerm && filteredList && filteredList.length > 0 && /*#__PURE__*/React.createElement(Field.Select, {
    name: "filteredList",
    placeholder: selectFieldPlaceholderText,
    items: Object.values(filteredList),
    onInputValueChange: function onInputValueChange(selectedValue) {
      var index = fields.value.findIndex(function (value) {
        return value === selectedValue;
      });
      selectedValue && setRow(index);
    }
  })), /*#__PURE__*/React.createElement(Box, {
    width: 1 / 3
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    color: "#bbb",
    fontSize: 12
  }, foundLabel, " \xA0", !!searchTerm && filteredList && filteredList.length > 0 && "".concat(filteredList.length, " / "), fields.length)))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: Math.min(MAX_CONTAINER_HEIGHT, ROW_HEIGHT * (fields && fields.length))
    }
  }, /*#__PURE__*/React.createElement(AutoSizer, null, function (_ref4) {
    var height = _ref4.height,
      width = _ref4.width;
    return /*#__PURE__*/React.createElement(List, {
      scrollToIndex: row || 0,
      width: width,
      height: height,
      rowCount: fields.length,
      rowHeight: cache.rowHeight,
      rowRenderer: function rowRenderer(_ref5) {
        var key = _ref5.key,
          index = _ref5.index,
          style = _ref5.style,
          isScrolling = _ref5.isScrolling,
          parent = _ref5.parent;
        return /*#__PURE__*/React.createElement(Row, {
          key: key,
          index: index,
          style: style,
          parent: parent,
          isScrolling: isScrolling,
          name: "".concat(name, "[").concat(index, "]"),
          fields: fields,
          render: render,
          disableRemove: disableRemove,
          rowLoaderText: rowLoaderText,
          cache: cache
        });
      }
    });
  })));
};
var ArrayField = function ArrayField(_ref6) {
  var label = _ref6.label,
    horizontal = _ref6.horizontal,
    name = _ref6.name,
    addText = _ref6.addText,
    disableAdd = _ref6.disableAdd,
    disableRemove = _ref6.disableRemove,
    _ref6$addButton = _ref6.addButton,
    AddButton = _ref6$addButton === void 0 ? AddLink : _ref6$addButton,
    _ref6$removeButton = _ref6.removeButton,
    RemoveButtom = _ref6$removeButton === void 0 ? RemoveLink : _ref6$removeButton,
    children = _ref6.children,
    _ref6$render = _ref6.render,
    render = _ref6$render === void 0 ? children : _ref6$render,
    rowLoaderText = _ref6.rowLoaderText,
    searchPlaceholderText = _ref6.searchPlaceholderText,
    foundLabel = _ref6.foundLabel,
    isVirtualizedList = _ref6.isVirtualizedList,
    selectFieldPlaceholderText = _ref6.selectFieldPlaceholderText;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    row = _useState4[0],
    setRow = _useState4[1];
  useEffect(function () {
    !searchTerm && setRow(0);
  }, [searchTerm]);
  return /*#__PURE__*/React.createElement(FieldView, {
    label: label,
    horizontal: horizontal,
    wrapperIsLabel: false
  }, /*#__PURE__*/React.createElement(FieldArray, {
    name: name
  }, function (_ref7) {
    var fields = _ref7.fields;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isVirtualizedList ? /*#__PURE__*/React.createElement(VirtualizedList, {
      name: name,
      fields: fields,
      row: row,
      render: render,
      setRow: setRow,
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm,
      disableRemove: disableRemove,
      searchPlaceholderText: searchPlaceholderText,
      foundLabel: foundLabel,
      rowLoaderText: rowLoaderText,
      selectFieldPlaceholderText: selectFieldPlaceholderText
    }) : fields.map(function (name, index) {
      return /*#__PURE__*/React.createElement(Item, {
        key: name
      }, render({
        name: name,
        index: index,
        fields: fields
      }), disableRemove || /*#__PURE__*/React.createElement(RemoveButtom, {
        icon: /*#__PURE__*/React.createElement(RemoveIcon, null),
        index: index,
        onClick: function onClick() {
          return fields.remove(index);
        }
      }));
    }), disableAdd || addText && /*#__PURE__*/React.createElement(AddButton, {
      addText: addText,
      onClick: function onClick() {
        fields.push();
        setRow(fields && fields.length);
      }
    }));
  }));
};
var AddLink = function AddLink(_ref8) {
  var onClick = _ref8.onClick,
    addText = _ref8.addText;
  return /*#__PURE__*/React.createElement(Link, {
    icon: /*#__PURE__*/React.createElement(AddIcon, null),
    onClick: onClick,
    size: "xs",
    iconReverse: true,
    upperCase: true,
    bold: true
  }, addText);
};
export default ArrayField;
var Item = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var RemoveLink = styled(Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 100%;\n"])));